import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage } from 'utils/messages'

let customActions = {}

const getDataForDocumentReport = ({ reportInitialDate, reportFinalDate }) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(
				'/document/utils/get_data_for_document_report',
				{
					method: 'GET',
					headers: {
						Authorization: state.app.user.token,
					},
					params: {
						initial_date: reportInitialDate + ' 00:00:00',
						final_date: reportFinalDate + ' 23:59:59',
					},
				}
			)

			return res.body
		} catch (error) {
			// Handling the error
		}
	}
}

const getDocumentDashboardData = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/document/utils/get_document_dashboard_data`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options,
		})

		return res.body
	}
}

const createDocument = (document) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/document/create_document`, {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(document),
				successMessage: `Documento creado correctamente.`
			})

			return dispatch({
				type: `ADD_DOCUMENT`,
				response: res.body,
			})
		} catch (error) {
			console.log(error)
		}

	}
}

const fetchDocumentsByEntity = (entity) => {
	return async (_, getState) => {
		const state = getState()

		const res = await callApi(`/document/fetch_documents_by_entity/${entity}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			}
		})

		return res.body
	}
}

customActions = {
	...customActions,
	getDataForDocumentReport,
	getDocumentDashboardData,
	createDocument
}

const actions = {
	...crud('document', 'el documento', 'los documentos'),
	...customActions,
}

export default { ...actions, fetchDocumentsByEntity }
